module.exports = __webpack_public_path__ + "img/promotion-icon.6192a78.svg?v=1764903765445";